import {breakpoints} from '../constants/breakpoints';

const selectors = {
  header: '.js-header',
  topBar: '.js-top-bar',
};

const classNames = {
  scrolled: 'l-header--scrolled',
  white: 'l-header--white',
  fixed: 'l-header--fixed',
};

const vars = {
  topbarHeight: 0,
  desktopOffset: 200,
  mobileOffset: 100,
};

const offset = window.innerWidth > breakpoints.tablet ? vars.desktopOffset : vars.mobileOffset;

const handleHeader = () => {
  const header = document.querySelector(selectors.header);
  if (!header) return;

  const topBar = document.querySelector(selectors.topBar);
  if (topBar) {
    vars.topbarHeight = topBar.clientHeight;
  }

  let prevScroll = window.scrollY;

  const handleHeader = () => {
    let currentScroll = window.scrollY;

    if (currentScroll > offset) {
      if (currentScroll > prevScroll) {
        header.classList.add(classNames.scrolled);
      } else {
        header.classList.remove(classNames.scrolled);
      }

      if (topBar) {
        header.classList.add(classNames.fixed);
      }
      header.classList.add(classNames.white);
    } else if (currentScroll > vars.topbarHeight) {
      if (topBar) {
        header.classList.add(classNames.fixed);
      }
    } else {
      header.classList.remove(classNames.white);
      if (topBar) {
        header.classList.remove(classNames.fixed);
      }
    }

    prevScroll = window.scrollY;
  };

  handleHeader();
  window.addEventListener('scroll', handleHeader);
};

export default handleHeader;
